
import { defineComponent } from "vue";

export default defineComponent({
  name: "Empty State",
  props: {
    name: String,
  },
});
